import { createFileRoute } from "@tanstack/react-router";
import { faqPageScript, i18nLinks, i18nOgMeta, localeUrl } from "@/lib/seo";
import { m } from "@/paraglide/messages";
import { StopwatchPage } from "@/tools/timer/pages/StopwatchPage";

export const Route = createFileRoute("/timer/stopwatch")({
  ssr: true,
  head: () => ({
    meta: [
      { title: m.timer_stopwatch_meta_title() },
      { name: "description", content: m.timer_stopwatch_meta_description() },
      { property: "og:title", content: m.timer_stopwatch_meta_title() },
      {
        property: "og:description",
        content: m.timer_stopwatch_meta_description(),
      },
      ...i18nOgMeta("/timer/stopwatch"),
    ],
    links: [...i18nLinks("/timer/stopwatch")],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: m.timer_breadcrumb_home(),
              item: localeUrl(`/`),
            },
            {
              "@type": "ListItem",
              position: 2,
              name: m.timer_tool_name(),
              item: localeUrl(`/timer`),
            },
            {
              "@type": "ListItem",
              position: 3,
              name: m.timer_nav_stopwatch(),
              item: localeUrl(`/timer/stopwatch`),
            },
          ],
        }),
      },
      faqPageScript([
        { q: m.timer_stopwatch_faq1_q(), a: m.timer_stopwatch_faq1_a() },
        { q: m.timer_stopwatch_faq2_q(), a: m.timer_stopwatch_faq2_a() },
        { q: m.timer_stopwatch_faq3_q(), a: m.timer_stopwatch_faq3_a() },
        { q: m.timer_stopwatch_faq4_q(), a: m.timer_stopwatch_faq4_a() },
      ]),
    ],
  }),
  component: StopwatchPage,
});
